<template>
    <div class="row">
        <div class="col-lg-12">
            <div v-if="loggedInUserRole === 'BRANCH' && isPortalEnabled">
                <PageTitle title="Orders -In Processing"
                           v-bind:crumbs="[{href:'/point_of_sale',title:'Home'},{href:'/orders',title:'orders'}]"/>
              <div class="tabs-container">
                <ul class="nav nav-tabs nav-justified margin-horizontal-15">
                  <li class="active nav_custom_class text-center width-50"><a data-toggle="tab" href="#current-orders">Current Orders</a></li>
                  <li class="nav_custom_class text-center width-50" @click="refreshPastOrders"><a data-toggle="tab" href="#old-orders">Past Orders</a></li>
                </ul>
                <div class="tab-content">
                  <div id="current-orders" class="tab-pane active">
                    <div class="panel-body">
                      <OrderNew></OrderNew>
                    </div>
                  </div>
                  <div id="old-orders" class="tab-pane">
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12">
                        <Orders ref="pastOrders" :not-from-branch="true"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
import OrderNew from "../components/orders/branch/OrderNew";
import Orders from "@/views/Orders.vue";

export default {
    name: "BranchOrders",
    components: {
        Orders,
        PageTitle,
        OrderNew
    },
    data() {
        return {
            statusesWithoutUnAssignedOrder: [],
            isHideSpinner: ""
        }
    },
    created() {
        this.statusesWithoutUnAssignedOrder = [
            this.$status.ASSIGNED_TO_BRANCH.id,
            this.$status.ACCEPTED_BY_BRANCH.id,
            this.$status.READY_FOR_PICKUP.id,
            this.$status.CANCELED.id
        ]
    },     
    computed: {
        loggedInUserRole() {
            if (this.$store.state.user.fullName !== undefined && this.$store.state.user.userRolesById[0]) {
                return this.$store.state.user.userRolesById[0].role.split('_')[1]
            }
            return ""
        },
        isPortalEnabled() {
            return (this.$store.state.user.branch && this.$store.state.user.branch.isPortalEnabled)
        },
    },
    methods: {
      refreshPastOrders() {
        this.$refs.pastOrders.resetData();
        this.$refs.pastOrders.dtTable.draw();
      }
    }
}
</script>

<style scoped>
.margin-horizontal-15 {
    margin-left: -15px !important;
    margin-right: -15px !important;
}
.width-50 {
  width: 50% !important;
}
</style>
